import {
    fetchOrganisationFailure,
    fetchOrganisationRequest,
    fetchOrganisationSuccess,
    patchOrganisationFailure,
    patchOrganisationRequest,
    patchOrganisationSuccess,
} from '@actions/assessments';
import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { Organisation } from 'src/types/shared/Organisation';

interface OrganisationState {
    isFetching: boolean;
    fetchError: string | null;
    isPatching: boolean;
    patchSuccess: boolean;
    patchError: string | null;
    organisation: Record<number, Organisation>;
}

const initialState: OrganisationState = {
    isFetching: false,
    fetchError: null,
    isPatching: false,
    patchSuccess: false,
    patchError: null,
    organisation: {},
};

export default createReducer(initialState, {
    [fetchOrganisationRequest.type]: handleFetchRequest,
    [fetchOrganisationFailure.type]: handleFetchFailure,
    [fetchOrganisationSuccess.type]: handleFetchOrganisationSuccess,
    [patchOrganisationRequest.type]: handlePatchRequest,
    [patchOrganisationFailure.type]: handlePatchFailure,
    [patchOrganisationSuccess.type]: handlePatchOrganisationSuccess,
});

function handleFetchRequest(state: OrganisationState) {
    state.fetchError = null;
    state.isFetching = true;
}

function handleFetchFailure(state: OrganisationState, action: PayloadAction<string>) {
    state.fetchError = action.payload;
    state.isFetching = false;
}

function handleFetchOrganisationSuccess(
    state: OrganisationState,
    action: PayloadAction<Organisation>,
) {
    state.organisation[action.payload.submissionId] = action.payload;
    state.isFetching = false;
}

function handlePatchRequest(state: OrganisationState) {
    state.isPatching = true;
    state.patchSuccess = false;
    state.patchError = null;
}

function handlePatchFailure(state: OrganisationState, action: PayloadAction<string>) {
    state.patchError = action.payload;
    state.isPatching = false;
}

function handlePatchOrganisationSuccess(
    state: OrganisationState,
    action: PayloadAction<Organisation>,
) {
    state.organisation[action.payload.submissionId] = action.payload;
    state.isPatching = false;
    state.patchSuccess = true;
}
